import React from 'react';
import message from '../components/Brand/brandMessage';
import { SettingsIcon } from '../components/Brand/Icon';
import { getLanguage } from '../utils/func';
import { appLocalStorage } from '../utils/storage';
import config from '../utils/config';
import { subscribeSessionChanges } from '../hooks/useSessionIdentity';
import { legalCopy } from './copy';
import { manageLegalConsent } from './consent';

export function isConsentRequired(value) {
  return (typeof value === 'string' ? value
    : value?.errorCode || value?.response?.data?.error?.code || value?.code) === 'LEGAL_CONSENT_REQUIRED';
}

// Use one notice for all consent-dependent actions, without replaying writes
// or replacing the current editor. Only an explicit tap opens account choices.
export function showConsentRequired(value) {
  if (!isConsentRequired(value)) return false;
  const token = appLocalStorage.getItem(config.token);
  if (!token) return true;
  const copy = legalCopy(getLanguage());
  let unsubscribe;
  const notice = message.warning({
    content: copy.requiredNotice,
    duration: 8,
    layout: 'stacked',
    closeLabel: copy.cancel,
    action: {
      label: copy.settings,
      icon: <SettingsIcon />,
      onClick: () => {
        if (appLocalStorage.getItem(config.token) === token) void manageLegalConsent();
      },
    },
    onClose: () => unsubscribe?.(),
  });
  unsubscribe = subscribeSessionChanges(() => {
    if (appLocalStorage.getItem(config.token) !== token) notice?.close();
  });
  return true;
}
